<template>
    <div class="tooltip-area">
        <div class="tooltip">
            <slot name="default">
                <p>{{ i18n.t(text) }}</p>
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { i18n } from '@/libraries/i18n';

    export default defineComponent({
        name: 'Tooltip',
        props: {
            text: {
                type: String,
                default: '',
            },
        },
        setup() {
            return {
                i18n,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/tooltip";
</style>
